import Typography from "@mui/material/Typography";

export default function CodeNotFound() {
  return (
    <>
      <Typography
        variant={`h6`}
        sx={{ minHeight: "70vh", pt: 5 }}
        textAlign={"center"}
      >
        Could not find details for this product. Please try again.
      </Typography>
    </>
  );
}
